// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * THIS IS AN AUTO-GENERATED FILE - DO NOT EDIT!
 *
 * Any changes you make here may be lost.
 *
 * If you need to make changes, please do so in the original source file, \{project-root\}/sources/custom
 */

import ModelClient from "./modelClient.js";

export * from "./clientDefinitions.js";
export * from "./isUnexpected.js";
export * from "./modelClient.js";
export * from "./models.js";
export * from "./outputModels.js";
export * from "./parameters.js";
export * from "./responses.js";
export type { ErrorModel } from "@azure-rest/core-client";

export default ModelClient;
